import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle, Heart, Ban } from 'lucide-react';
export function ForWhom() {
  const yesItems = [{
    text: 'Eres una madre trabajadora con mañanas caóticas',
    emoji: '💪'
  }, {
    text: 'Quieres que tu hijo deje la comida procesada y las galletas del recreo',
    emoji: '🥦'
  }, {
    text: 'Necesitas ahorrar dinero optimizando ingredientes en el súper',
    emoji: '💰'
  }, {
    text: 'Deseas cerrar la mochila y sentir: "Hoy va bien alimentado"',
    emoji: '✅'
  }];
  const noItems = [{
    text: 'Tienes un chef privado que cocina por ti',
    emoji: '👨‍🍳'
  }, {
    text: 'Te encanta pasar 2 horas decorando comida con formas de unicornio',
    emoji: '🦄'
  }, {
    text: 'No te importa que tus hijos coman azúcar y conservadores todos los días',
    emoji: '🍬'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -12
    },
    visible: {
      opacity: 1,
      x: 0
    }
  };
  return <section className="py-10 px-4 bg-cream-50" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-86">
          <h2 className="text-2xl md:text-3xl font-black text-charcoal-900 mb-2" data-id="element-87">
            ¿Este Kit es para <span className="text-naranja-500" data-id="element-88">ti</span>?
          </h2>
          <p className="text-base text-charcoal-600 font-medium" data-id="element-89">
            Descúbrelo en 10 segundos 👇
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-90">
          {/* YES Card */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 180,
          damping: 18
        }} className="relative bg-white rounded-2xl overflow-hidden shadow-[0_6px_24px_-4px_rgba(122,175,135,0.3)] border border-sage-200" data-id="element-91">
            {/* Header */}
            <div className="bg-sage-500 px-6 py-4 flex items-center gap-3" data-id="element-92">
              <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-93">
                <Heart className="w-5 h-5 text-white" data-id="element-94" />
              </div>
              <h3 className="text-lg font-black text-white" data-id="element-95">
                SÍ es para ti si...
              </h3>
            </div>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="p-5 space-y-3" data-id="element-96">
              {yesItems.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-3 bg-sage-50 p-3 rounded-xl" data-id="element-97">
                  <CheckCircle2 className="w-5 h-5 text-sage-600 flex-shrink-0 mt-0.5" data-id="element-98" />
                  <span className="text-charcoal-800 text-sm font-medium leading-snug" data-id="element-99">
                    {item.emoji} {item.text}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          {/* NO Card */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 180,
          damping: 18,
          delay: 0.15
        }} className="relative bg-white rounded-2xl overflow-hidden shadow-[0_6px_24px_-4px_rgba(251,133,0,0.2)] border border-naranja-100" data-id="element-100">
            {/* Header */}
            <div className="bg-charcoal-800 px-6 py-4 flex items-center gap-3" data-id="element-101">
              <div className="w-9 h-9 bg-white/10 rounded-xl flex items-center justify-center" data-id="element-102">
                <Ban className="w-5 h-5 text-naranja-300" data-id="element-103" />
              </div>
              <h3 className="text-lg font-black text-white" data-id="element-104">
                NO es para ti si...
              </h3>
            </div>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} className="p-5 space-y-3" data-id="element-105">
              {noItems.map((item, i) => <motion.li key={i} variants={itemVariants} className="flex items-start gap-3 bg-cream-50 p-3 rounded-xl" data-id="element-106">
                  <XCircle className="w-5 h-5 text-charcoal-400 flex-shrink-0 mt-0.5" data-id="element-107" />
                  <span className="text-charcoal-600 text-sm font-medium leading-snug" data-id="element-108">
                    {item.emoji} {item.text}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}